// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import {
  InputOTPComponent,
  ParagraphComponent,
  SkeletonComponent,
  SnackbarComponent,
} from '@openbank/ziniaweb-ui-components';
// Constants
import {
  HASHED_PHONE_SKELETON_PROPS,
  PARAGRAPH_PHONE_PROPS,
  PARAGRAPH_PROPS,
} from './constants/contract-otp.constants';
// Configurations
import {
  inputOtpConfiguration,
  snackbarConfiguration,
} from './configurations/contract-otp.configurations';
// Hooks
import { useContractOtpHook } from './hooks/contract-otp.hook';
// Styles
import {
  ContractOtpDescriptionWrapperStyled,
  ContractOtpWrapperStyled,
  HashedPhoneWrapperStyled,
} from './contract-otp.view.styled';
// Translations
import translations from './translations/contract-otp.translations';
// Utils
import { isOtpDelay } from './utils/contract-otp.utils';

const ContractOtpView = (): React.JSX.Element => {
  const {
    formatMessage,
    handleChangeOtpCode,
    handleClearOtp,
    handleResendOtp,
    hashedPhone,
    otpInfo,
    handleOpenCloseSnackbar,
    verifyInfo,
    handleTextboxClickTracking,
  } = useContractOtpHook();

  return (
    <ContractOtpWrapperStyled>
      <ContractOtpDescriptionWrapperStyled>
        <ParagraphComponent {...PARAGRAPH_PROPS}>
          <FormattedMessage id={translations.ENTER_CODE_SENT} />
        </ParagraphComponent>
        <ParagraphComponent {...PARAGRAPH_PHONE_PROPS}>
          {!hashedPhone && (
            <HashedPhoneWrapperStyled>
              <SkeletonComponent {...HASHED_PHONE_SKELETON_PROPS} />
            </HashedPhoneWrapperStyled>
          )}
          {hashedPhone}
        </ParagraphComponent>
      </ContractOtpDescriptionWrapperStyled>
      <div>
        <InputOTPComponent
          {...inputOtpConfiguration({
            formatMessage,
            handleChangeOtpCode,
            handleClearOtp,
            handleResendOtp,
            handleTextboxClickTracking,
            otpInfo,
            verifyInfo,
          })}
        />
      </div>
      {isOtpDelay(otpInfo.delay) && (
        <ParagraphComponent {...PARAGRAPH_PROPS}>
          <FormattedMessage id={translations.OTP_DELAY} values={{ delay: otpInfo.delay }} />
        </ParagraphComponent>
      )}
      {otpInfo.open && (
        <SnackbarComponent {...snackbarConfiguration({ otpInfo, handleOpenCloseSnackbar })} />
      )}
    </ContractOtpWrapperStyled>
  );
};

export { ContractOtpView };
